import { render, staticRenderFns } from "./insight.vue?vue&type=template&id=7a44bf66&"
import script from "./insight.vue?vue&type=script&lang=js&"
export * from "./insight.vue?vue&type=script&lang=js&"
import style0 from "./insight.vue?vue&type=style&index=0&id=7a44bf66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports